import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { IBreadcrumbsAndMenu, ITab, IMenuOption } from "../../../types/global";
import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import { Box, Typography } from "@mui/material";
import CustomizedButton from "../../../components/Custom/CustomizedButton";
import CustomizedTab from "../../../components/Custom/CustomizedTab";
import QuotationTable from "../../../components/Table/Sales/Quotation";
import CustomizedMenuOptions from "../../../components/Custom/CustomizedMenuOptions";
import ExporterSalesModal from "../../../components/UI/Modal/ExporterSalesModal";
import { useModal } from "../../../hooks/use-modal";
import { SalesExportType } from "../../../generated/sales";

const Quotation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const isFilter = searchParams.get("filter");

  const { modal, openModalHandler, closeModalHandler } = useModal();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("sales.index"),
      to: "/sales",
    },
    {
      name: t("sales.quotation.index"),
    },
  ];

  const tabs: ITab[] = [
    {
      label: t("status.all"),
      path: `${pathname}`,
    },
    {
      label: t("status.draft"),
      path: `${pathname}?filter=draft`,
    },
    {
      label: t("status.wait_approve"),
      path: `${pathname}?filter=wait_approve`,
    },
    {
      label: t("status.not_approved"),
      path: `${pathname}?filter=not_approved`,
    },
    {
      label: t("status.wait_accept"),
      path: `${pathname}?filter=wait_accept`,
    },
    {
      label: t("status.accepted"),
      path: `${pathname}?filter=accepted`,
    },
    {
      label: t("status.finished"),
      path: `${pathname}?filter=finished`,
    },
    {
      label: t("status.cancelled"),
      path: `${pathname}?filter=cancelled`,
    },
  ];

  const options: IMenuOption[] = [
    {
      value: t("sales.export"),
    },
  ];

  const currentTab = pathname + (isFilter ? `?filter=${isFilter}` : "");

  return (
    <>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <Box sx={{ display: "flex", justifyContent: "space-between", my: 3 }}>
        <Typography variant="h5">{t("sales.quotation.index")}</Typography>
        <Box display="flex" gap={1}>
          <CustomizedButton
            title={`${t("button.create")}${t("sales.quotation.index")}`}
            variant="contained"
            onClick={() => navigate(`${pathname}/add`)}
            addIcon
          />
          <CustomizedMenuOptions
            isIcon
            options={options}
            onSelect={(e) => {
              const value = e.target as HTMLElement;
              switch (value.innerText) {
                case `${t("sales.export")}`:
                  openModalHandler();
                  break;
                default:
              }
            }}
          />
        </Box>
      </Box>
      <CustomizedTab tabs={tabs} currentTab={currentTab} divider table />
      <QuotationTable isFilter={isFilter} />
      <ExporterSalesModal
        open={modal}
        closeModalHandler={closeModalHandler}
        documentType={SalesExportType.Quotation}
      />
    </>
  );
};

export default Quotation;
